/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import ImageScaling, { ImageScalingStrings } from '../enums/ImageScaling'

export default function getImageScalingStyle(imageScaling: ImageScalingStrings) {
  switch (imageScaling) {
    case ImageScaling.ACTUAL:
      return 'inherit'
    case ImageScaling.CONTAIN:
      return 'contain'
    default:
      throw new Error(`Unknown image scaling: ${imageScaling}.`)
  }
}
